<template>
    <div>
        <!-- <topSearch></topSearch> -->
        <!-- <breadcrumb></breadcrumb> -->

        <div class="top-title-content">
            <span class="title">계약관리</span>
            <span class="txt">핏투데이케어에 가입한 업체 계약 및 결제정보 등록, 수정, 삭제가 가능합니다.</span>
        </div>

        <div class="com-table-top">
            <span class="title">계약등록</span>
        </div>
        <loading-spinner v-if="isLoading"></loading-spinner>
        <div v-else class="com-table-wrap">
            <span class="top-title"><span class="title">계약정보</span></span>
            <div class="info-edit-table">
                <div class="table-wrapper">
                    <table>
                        <colgroup>
                            <col style="width: 156px" />
                            <col style="width: auto" />
                        </colgroup>
                        <tbody>
                            <tr>
                                <th>
                                    센터
                                    <span class="imp">*</span>
                                </th>
                                <td>
                                    <input v-model="editField.center.name" class="w220" readonly type="text" />
                                    <button class="com-btn" @click="onClickCenterDlg">검색</button>
                                </td>
                            </tr>
                            <tr>
                                <th>
                                    사업자번호
                                    <span class="imp">*</span>
                                </th>
                                <td>
                                    <div class="com-tel">
                                        <input
                                            v-model="editField.bizNo[0]"
                                            maxlength="3"
                                            type="text"
                                            @keypress="isNumber($event)"
                                        />
                                        <span class="bar">-</span>
                                        <input
                                            v-model="editField.bizNo[1]"
                                            maxlength="2"
                                            type="text"
                                            @keypress="isNumber($event)"
                                        />
                                        <span class="bar">-</span>
                                        <input
                                            v-model="editField.bizNo[2]"
                                            maxlength="5"
                                            type="text"
                                            @keypress="isNumber($event)"
                                        />
                                    </div>
                                    <!--
                                <input type="text" class="w400" v-model="editField.center.bizNo">
                                --></td>
                            </tr>
                            <tr>
                                <th>
                                    가입자명
                                    <span class="imp">*</span>
                                </th>
                                <td>
                                    <input v-model="editField.center.contactUserName" class="w400" type="text" />
                                </td>
                            </tr>
                            <tr>
                                <th>
                                    가입자 휴대폰번호
                                    <span class="imp">*</span>
                                </th>
                                <td>
                                    <div class="com-tel">
                                        <input
                                            v-model="editField.contactUserTel[0]"
                                            maxlength="3"
                                            type="text"
                                            @keypress="isNumber($event)"
                                        />
                                        <span class="bar">-</span>
                                        <input
                                            v-model="editField.contactUserTel[1]"
                                            maxlength="4"
                                            type="text"
                                            @keypress="isNumber($event)"
                                        />
                                        <span class="bar">-</span>
                                        <input
                                            v-model="editField.contactUserTel[2]"
                                            maxlength="4"
                                            type="text"
                                            @keypress="isNumber($event)"
                                        />
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <th>
                                    매출직원
                                    <span class="imp">*</span>
                                </th>
                                <td>
                                    <select-form
                                        :select-data="['선택', ...editField.staff.names]"
                                        :select-value="['', ...editField.staff.values]"
                                        :selected-value="editField.staff.selectedId"
                                        class="w240"
                                        @update:set="(val) => (editField.staff.selectedId = val)"
                                    ></select-form>
                                </td>
                            </tr>
                            <tr>
                                <th>프로그램</th>
                                <td>
                                    <select-form
                                        :select-data="['선택', ...editField.program.names]"
                                        :select-value="['', ...editField.program.values]"
                                        :selected-value="selectedProgramId"
                                        class="w240"
                                        @update:set="(val) => (selectedProgramId = val)"
                                    ></select-form>
                                    <table class="sub-table">
                                        <colgroup>
                                            <col style="width: 150px" />
                                            <col style="width: auto" />
                                        </colgroup>
                                        <tbody>
                                            <tr>
                                                <th>사용기간</th>
                                                <td>
                                                    <div class="com-calendar-wrap">
                                                        <single-calendar
                                                            :start-date="editField.program.startDate"
                                                            @update="onUpdateProgramStartDate"
                                                        ></single-calendar>
                                                        <div class="com-dash"><span class="dash">~</span></div>
                                                        <single-calendar
                                                            :end-date="editField.program.endDate"
                                                            @update="onUpdateProgramEndDate"
                                                        ></single-calendar>
                                                    </div>
                                                </td>
                                            </tr>
                                            <tr>
                                                <th>계약금액</th>
                                                <td>
                                                    <input
                                                        v-model="editField.program.price"
                                                        :disabled="selectedProgramId === ''"
                                                        class="w130"
                                                        type="text"
                                                        @keypress="isNumber($event)"
                                                        @keyup="onKeyUpProgramPrice"
                                                    />
                                                    <span class="txt">원</span>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </td>
                            </tr>
                            <!-- <tr>
                            <th>문자서비스</th>
                            <td>
                                <select-form :select-data='["사용안함", ...editField.mms.values]'
                                             :select-value="['', ...editField.mms.values]"
                                             :selected-value='selectedMmsPeriod'
                                             class='w240' @update:set='val => selectedMmsPeriod = val'></select-form>
                                <table class='sub-table'>
                                    <colgroup>
                                        <col style='width: 150px;'>
                                        <col style='width: auto;'>
                                    </colgroup>
                                    <tbody>
                                    <tr>
                                        <th>사용기간</th>
                                        <td>
                                            <div class='com-calendar-wrap'>
                                                <single-calendar :start-date='editField.mms.startDate'
                                                                 @update='updateMmsStartDate'></single-calendar>
                                                <span class='dash'>~</span>
                                                <single-calendar :end-date='editField.mms.endDate'
                                                                 @update='updateMmsEndDate'></single-calendar>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>계약금액</th>
                                        <td>
                                            <input v-model='editField.mms.price' :disabled="selectedMmsPeriod === ''"
                                                   class='w130' type='text'
                                                   @keypress='isNumber($event)' @keyup='onKeyUpMmsPrice'><span
                                            class='txt'>원</span>
                                        </td>
                                    </tr>
                                    </tbody>
                                </table>
                            </td>
                        </tr> -->
                            <tr>
                                <th>부가서비스</th>
                                <td>
                                    <div
                                        v-for="(item, index) in product.additional"
                                        :key="index"
                                        class="check-input-line"
                                    >
                                        <div class="com-check w200">
                                            <input
                                                :id="`check-1-${index}`"
                                                v-model="item.checked"
                                                name="check-1"
                                                type="checkbox"
                                                @change="onChangeAdditionalService(item)"
                                            />
                                            <label :for="`check-1-${index}`">{{ item.f_namee }}</label>
                                        </div>
                                        <input
                                            :id="item.f_namee"
                                            :value="item.f_price | numberFormatFilter"
                                            class="w130"
                                            type="text"
                                            @keypress="isNumber($event)"
                                            @keyup="onKeyUpAdditionalServicePrice"
                                        />
                                        <span class="txt">원</span>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <th>계약일</th>
                                <td>
                                    <single-calendar
                                        :start-date="editField.contractDate"
                                        @update="(v) => (editField.contractDate = v)"
                                    ></single-calendar>
                                </td>
                            </tr>
                            <tr>
                                <th>메모</th>
                                <td>
                                    <textarea v-model="editField.memo" class="com-textarea"></textarea>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div class="com-card-form">
                    <div class="top-area">
                        <div class="line">
                            <span v-if="editField.program.selectedId !== ''" class="count">
                                <span class="txt">{{ editField.program.info.f_namee }}</span>
                                <span class="num">{{ editField.program.price | numberFormatFilter }}</span>
                                원
                            </span>
                            <span v-if="editField.mms.selectedValue !== ''" class="count">
                                <span class="txt">문자서비스 {{ editField.mms.selectedValue }}개월</span>
                                <span class="num">{{ editField.mms.price | numberFormatFilter }}</span>
                                원
                            </span>
                            <span v-for="(item, index) in editField.additional" :key="index" class="count">
                                <span class="txt">{{ item.f_namee }}</span>
                                <span class="num">{{ item.f_price | numberFormatFilter }}</span>
                                원
                            </span>
                            <!--                            <span class="count"><span class="txt">터치모니터</span> <span class="num">475,200</span> 원</span>-->
                        </div>
                        <div class="line">
                            <span class="txt">총 결제금액 :</span>
                            <span class="input-box">
                                <input :value="totalPrice | numberFormatFilter" class="w220" disabled type="text" />
                                원
                            </span>
                        </div>
                    </div>
                    <div class="middle-area">
                        <!-- 결제 정보 -->
                        <payment-info
                            v-for="(b, index) in editField.bills"
                            :key="index"
                            :bill-data="b"
                            :index="index"
                            :is-show-btn-delete-payment="false"
                            :is-use-mileage="false"
                            :is-use-mileage-btn="false"
                            :is-use-receipt="false"
                            :isContract="true"
                            :totalBuyPrice="totalPrice"
                            @on-change="onChangePaymentFields"
                            @on-click-delete="onClickDeletePaymentFields"
                        ></payment-info>

                        <div v-if="false" class="com-send-btn">
                            <!-- 2021-03-10 : 제거 -->
                            <button class="com-btn blue" @click="onClickAddPayment">결제정보추가</button>
                        </div>
                    </div>
                </div>
                <div class="bottom-btn">
                    <button class="com-btn" @click="onClickCancel">취소</button>
                    <button v-if="!isModify" class="com-btn blue" @click="onClickRegist">등록</button>
                    <button v-else class="com-btn blue" @click="onClickModify">수정</button>
                </div>
            </div>
        </div>

        <!-- 센터 검색 팝업 -->
        <div v-show="centerDlg.isVisible" class="layer-pop square-type">
            <div class="view-content">
                <div class="scroll-area com-scroll-y">
                    <span class="sub-title">센터 검색 결과</span>
                    <div class="top-search-area">
                        <div class="right">
                            <input v-model="centerDlg.searchStr" class="w220" placeholder="센터명" type="text" />
                            <button class="com-btn" @click="onClickSearchCenter">검색</button>
                        </div>
                    </div>
                    <table class="com-table">
                        <colgroup>
                            <col style="width: 70px" />
                            <col style="width: 120px" />
                            <col style="width: 160px" />
                            <col style="width: 160px" />
                        </colgroup>
                        <thead>
                            <tr>
                                <th></th>
                                <th>센터명</th>
                                <th>담당자명</th>
                                <th>담당자 연락처</th>
                            </tr>
                        </thead>
                        <tbody v-if="centerDlg.centerList.length > 0">
                            <tr v-for="(center, index) in centerDlg.centerList" :key="index">
                                <td>
                                    <div class="com-radio">
                                        <input
                                            :id="`rdo-center-${index}`"
                                            name="radio-pop"
                                            type="radio"
                                            @click="onClickCenterRadio(center)"
                                        />
                                        <label :for="`rdo-center-${index}`"></label>
                                    </div>
                                </td>
                                <td>{{ center.centerName }}</td>
                                <td>{{ center.contactUserName }}</td>
                                <td>{{ center.contactUserTel | phoneNumberFilter }}</td>
                            </tr>
                            <!-- <tr v-else>
                            <td colspan="100">등록된 내용이 없습니다.</td>
                        </tr> -->
                        </tbody>
                        <tbody v-else>
                            <tr>
                                <td colspan="100">등록된 내용이 없습니다.</td>
                            </tr>
                        </tbody>
                    </table>
                    <b-pagination
                        v-model="centerDlg.pagingInfo.page"
                        :per-page="centerDlg.pagingInfo.limit"
                        :total-rows="centerDlg.pagingInfo.totalItems"
                        align="center"
                        aria-controls="my-table"
                        first-class="first"
                        last-class="last"
                        next-class="next"
                        prev-class="prev"
                        @change="onChangeCenterPagination($event)"
                    ></b-pagination>
                    <div class="bottom-btn">
                        <button class="com-btn" @click="onClickCancelCenterDlg">취소</button>
                        <button
                            :disabled="centerDlg.selectedCenter === null"
                            class="com-btn blue"
                            @click="onClickSelectAndCloseCenterDlg"
                        >
                            선택
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import api from '@/assets/js/api';
import { pagingInfo } from '@/assets/js/common';
import moment from 'moment';
import EventBus from '../../../../assets/js/eventBus';
export default {
    name: 'businessContractEdit',
    props: {},
    watch: {
        selectedProgramId(newVal, oldVal) {
            if (newVal !== oldVal) {
                const { program } = this.editField;
                program.selectedId = newVal;
                this.updateProgramInfo(newVal);
            }
        },
        selectedMmsPeriod(newVal, oldVal) {
            if (newVal !== oldVal) {
                const { mms } = this.editField;
                mms.selectedValue = newVal;
                this.updateMmsInfo();
            }
        },
        totalPrice() {
            const { bills } = this.editField;
            bills[0].billPrice = this.totalPrice;
            console.log(this.totalPrice);
        },
    },
    computed: {
        today() {
            return moment().format('YYYY-MM-DD');
        },
        totalPrice() {
            const { product } = this;
            const { program, mms, additional } = this.editField;

            const programPrice = program.selectedId !== '' ? this.getPureNumber(program.price) : 0;
            const mmsPrice = mms.selectedValue !== '' ? this.getPureNumber(mms.price) : 0;
            let additionalPrice = 0;
            for (const d of additional) {
                additionalPrice += d.f_price;
            }
            return programPrice + mmsPrice + additionalPrice;
        },
        totalPrePrice() {
            const { product } = this;
            const { program, mms, additional } = this.editField;

            const programPrice = program.selectedId !== '' ? program.info.f_price : 0;
            const mmsPrice = mms.selectedValue !== '' ? parseInt(mms.selectedValue) * product.mms.f_price : 0;
            let additionalPrice = 0;
            for (const d of additional) {
                additionalPrice += d.f_price;
            }
            return programPrice + mmsPrice + additionalPrice;
        },
        isModify() {
            return this.contractId !== null;
        },
    },
    data() {
        return {
            contractId: null,
            contractInfo: {},
            isLoading: false,
            isMoreCard: false,
            selectedProgramId: '',
            selectedMmsPeriod: '',
            product: {
                program: {},
                mms: {},
                additional: [],
            },
            editField: {
                memo: '',
                bizNo: ['', '', ''],
                contactUserTel: ['', '', ''],
                center: {
                    id: null,
                    name: '',
                    contactUserName: '',
                    contactUserTel: '',
                    bizNo: '',
                    bizType: '',
                },
                contractDate: '',
                program: {
                    selectedId: '',
                    info: {},
                    names: [],
                    values: [],
                    startDate: '',
                    endDate: '',
                    price: '',
                    name: '',
                },
                mms: {
                    selectedValue: '',
                    values: [],
                    startDate: '',
                    endDate: '',
                    price: '',
                },
                additional: [],
                staff: {
                    selectedId: '',
                    names: [],
                    values: [],
                },
                bills: [],
            },
            centerDlg: {
                isVisible: false,
                centerList: [],
                searchStr: '',
                selectedCenter: null,
                pagingInfo: { ...pagingInfo },
            },
        };
    },
    mounted() {
        if (this.$route.params.id !== undefined) {
            this.contractId = this.$route.params.id;
        }

        this.init();
    },
    methods: {
        async init() {
            this.getProductList();
            this.getStaffList();

            const { editField } = this;

            // 문자서비스 선택값 초기화
            editField.mms.values = Array.from({ length: 24 }, (_, i) => (i + 1).toString());

            if (!this.isModify) {
                // 수정이 아닌 경우, 초기화
                const { today, editField } = this;

                // init values
                editField.contractDate = today;

                this.addBills();
            } else {
                // 수정인 경우, 기존 데이터 바인딩
                await this.getContractInfo();
                await this.getCenterInfo();
            }
        },
        async getContractInfo() {
            try {
                const { data } = await this.sendGetFtContract();
                this.contractInfo = data;

                console.log('contract', data);

                const { editField, contractInfo } = this;
                editField.staff.selectedId = contractInfo.contractStaffId.toString();
                editField.contractDate = contractInfo.contractedAt;
                editField.memo = contractInfo.memo;

                const additionalMap = {};
                for (const a of this.product.additional) {
                    additionalMap[a.f_id] = a;
                }

                // 연장 상품 선택
                const { ftContractProducts, ftContractBills } = data;
                for (const p of ftContractProducts) {
                    if (p.ftProductType == 'P') {
                        this.selectedProgramId = p.ftProductId.toString();
                        this.updateProgramInfo(this.selectedProgramId);

                        // 기존 계약가격 입력
                    } else if (p.ftProductType == 'M') {
                        this.selectedMmsPeriod = p.contractMonth.toString();
                        this.updateMmsInfo();

                        // 기존 계약가격 입력
                    } else if (p.ftProductType == 'B') {
                        const item = additionalMap[p.ftProductId];
                        item.checked = true;

                        item.f_price = p.ftProductBuyPrice;
                        editField.additional.push(item);
                    }
                }

                // 결제정보 입력
                for (const b of ftContractBills) {
                    this.addBills(b);
                }

                console.log('===> Success Loading contractInfo: ', data);
            } catch (error) {
                console.log(error);
                alert('오류가 발생했습니다.');
            }
        },
        sendGetFtContract() {
            return api.get(`/admin/api/ft/contract/${this.contractId}`);
        },
        async getProductList() {
            try {
                const { data } = await this.sendGetFtProduct();
                this.reorganizeProduct(data);
            } catch (error) {
                alert('오류가 발생했습니다.');
                console.log('===> Failed init page : ', error);
            }
        },
        sendGetFtProduct() {
            return api.get('/admin/api/ft/product', {
                params: {},
            });
        },
        async getStaffList() {
            try {
                const { data } = await this.sendGetFtStaff();
                const { names, values } = this.editField.staff;
                for (const d of data.items) {
                    names.push(d.s_namee);
                    values.push(d.s_id.toString());
                }
            } catch (error) {
                alert('오류가 발생했습니다.');
                console.log('===> Failed init page : ', error);
                // console.log(centerData);
            }
        },
        sendGetFtStaff() {
            const pInfo = { ...this.pagingInfo };
            pInfo.limit = 1000; // 모든 직원들을 가져오기 위함
            return api.get('/admin/api/ft/staff', {
                params: {
                    ...pInfo,
                },
            });
        },
        reorganizeProduct(data) {
            // 데이터를 각각의 상품 데이터에 입력
            const { product } = this;
            const { names, values } = this.editField.program;

            for (const d of data) {
                switch (d.f_prod_type_cd) {
                    case 'P': // 프로그램
                        product.program[d.f_id] = { ...d };
                        names.push(d.f_namee);
                        values.push(d.f_id.toString());
                        break;
                    case 'M': // 문자서비스
                        product.mms = d;
                        break;
                    case 'B': // 부가서비스
                        product.additional.push(d);
                        break;
                }
            }
        },
        onClickCancel() {
            if (this.isModify) {
                // 계약 수정인 경우
                this.$router.push({ path: `/madmin/business/contract/detail/${this.contractInfo.centerId}` });
            } else {
                // 계약 등록인 경우
                this.$router.push({ name: 'businessContractList' });
            }
        },
        async onClickCenterDlg() {
            this.centerDlg.pagingInfo = {
                ...this.pagingInfo,
            };

            const { pagingInfo } = this.centerDlg;

            pagingInfo.page = 1;
            pagingInfo.limit = 10;

            await this.searchCenter();
            this.centerDlg.isVisible = true;
        },
        onClickCancelCenterDlg() {
            this.closeCenterDlg();
            this.resetCenterDlg();
        },
        onClickSelectAndCloseCenterDlg() {
            const { selectedCenter } = this.centerDlg;

            if (selectedCenter !== null) {
                this.setCenterInfo(selectedCenter);
            }

            this.closeCenterDlg();
            this.resetCenterDlg();
        },
        setCenterInfo(data) {
            const { center } = this.editField;

            center.id = data.id;
            center.name = data.centerName;
            center.bizNo = data.bizNo;
            center.bizType = data.bizType;
            center.contactUserName = data.contactUserName;
            center.contactUserTel = data.contactUserTel;

            this.editField.bizNo = this.splitBizNo(data.bizNo);
            this.editField.contactUserTel =
                data.contactUserTel !== '' ? this.splitPhoneNumber(data.contactUserTel) : ['', '', ''];
        },
        closeCenterDlg() {
            this.centerDlg.isVisible = false;
        },
        resetCenterDlg() {
            const { centerDlg } = this;
            centerDlg.pagingInfo.page = 1;
            centerDlg.searchStr = '';
            centerDlg.selectedCenter = null;
        },
        // 센터 검색 API 호출
        async searchCenter() {
            try {
                // this.isLoading = true;
                const { centerDlg } = this;
                const { data } = await this.getCenterList();

                centerDlg.pagingInfo.totalPages = data.meta.totalPages;
                centerDlg.pagingInfo.page = data.meta.currentPage;
                centerDlg.pagingInfo.totalItems = data.meta.totalItems;
                centerDlg.pagingInfo.itemCount = data.meta.itemCount;

                centerDlg.centerList = data.items;
                // this.isLoading = false;
                console.log('===> Success Loading centerList : ', data);
            } catch (error) {
                console.log(error);
                alert('오류가 발생했습니다.');
            }
        },
        async getCenterInfo() {
            try {
                const { data } = await this.sendGetCenter();
                this.centerInfo = data;
                this.setCenterInfo(data);

                console.log('===> Success Loading centerInfo: ', data);
            } catch (error) {
                console.log(error);
                alert('오류가 발생했습니다.');
            }
        },
        sendGetCenter() {
            return api.get(`/admin/api/center/${this.contractInfo.centerId}`);
        },
        // 센터 목록 조회 API
        getCenterList() {
            const { centerDlg } = this;
            return api.get('/admin/api/center', {
                params: {
                    searchStr: centerDlg.searchStr,
                    ...centerDlg.pagingInfo,
                },
            });
        },
        // 이벤트 발생시 키워드 길이 체크
        onClickSearchCenter(e) {
            if (this.centerDlg.searchStr.length < 2) {
                return;
            }

            this.searchCenter();
        },
        onChangeCenterPagination(event) {
            const { pagingInfo } = this.centerDlg;
            pagingInfo.page = event;
            this.searchCenter();
        },
        onClickCenter(center) {
            console.log(center);
        },
        onClickCenterRadio(center) {
            this.centerDlg.selectedCenter = center;
        },
        updateProgramInfo(id) {
            console.log('did', id);
            const { program } = this.editField;

            if (id === '') {
                program.selectedId = '';
                program.version = '';
                program.info = {};
                program.startDate = '';
                program.endDate = '';
                program.price = '';
                program.name = '';

                return;
            }

            const { product } = this;
            const programInfo = product.program[id];

            program.info = programInfo;
            program.price = this.getNumberFormat(programInfo.f_price);

            if (this.isModify) {
                const { contractInfo } = this;
                contractInfo.ftContractProducts.forEach((g) => {
                    if (g.ftProductType == 'P') {
                        program.startDate = g.contractStartDate;
                    }
                });
            }

            if (program.startDate === '') {
                program.startDate = this.today;
            }

            program.endDate = moment(program.startDate).add({ months: programInfo.f_use_period }).format('YYYY-MM-DD');
        },
        updateMmsInfo() {
            const { mms } = this.editField;
            if (mms.selectedValue === '') {
                mms.selectedValue = '';
                mms.startDate = '';
                mms.endDate = '';
                mms.price = '';

                return;
            }

            const { product } = this;
            const mmsInfo = product.mms;

            if (this.isModify) {
                const { contractInfo } = this;
                contractInfo.ftContractProducts.forEach((g) => {
                    if (g.ftProductType == 'M') {
                        mms.startDate = g.contractStartDate;
                    }
                });
            }

            if (mms.startDate === '') {
                mms.startDate = this.today;
            }

            mms.endDate = moment(mms.startDate)
                .add({ months: parseInt(mms.selectedValue) })
                .format('YYYY-MM-DD');
            mms.price =
                mms.selectedValue !== '' ? this.getNumberFormat(mmsInfo.f_price * parseInt(mms.selectedValue)) : 0;
        },
        onUpdateProgramStartDate(d) {
            const { program } = this.editField;
            const { product } = this;

            program.startDate = d;

            if (program.selectedId !== '') {
                const programInfo = product.program[program.selectedId];
                program.endDate = moment(program.startDate)
                    .add({ months: programInfo.f_use_period })
                    .subtract({ days: 1 })
                    .format('YYYY-MM-DD');
            }
        },
        onUpdateProgramEndDate(d) {
            this.editField.program.endDate = d;
        },
        updateMmsStartDate(d) {
            const { mms } = this.editField;
            mms.startDate = d;

            if (mms.selectedValue !== '') {
                mms.endDate = moment(mms.startDate)
                    .add({ months: parseInt(mms.selectedValue) })
                    .subtract({ days: 1 })
                    .format('YYYY-MM-DD');
            }
        },
        updateMmsEndDate(d) {
            this.editField.mms.endDate = d;
        },
        onUpdateContractDate(d) {
            this.editField.contractDate = d;
        },
        onChangeAdditionalService(item) {
            const { additional } = this.editField;
            let index = '',
                i = 0;

            for (const d of additional) {
                if (d.f_id === item.f_id) {
                    index = i;
                    break;
                }
                i++;
            }

            if (item.checked && index === '') {
                additional.push(item);
            } else if (!item.checked && index !== '') {
                this.$delete(additional, index);
            }

            EventBus.$emit('changeEvent', this.totalPrice);
        },
        validateValues() {
            const { editField } = this;

            // 센터
            if (editField.center.id === null) {
                alert('센터를 선택하세요.');
                return false;
            }

            // 사업자 번호
            if (editField.bizNo[0] === null || editField.bizNo[1] === null || editField.bizNo[2] === null) {
                alert('사업자번호를 입력하세요.');
                return false;
            }

            // 가입자 명
            if (editField.contactUserName === '') {
                alert('가입자명을 입력하세요.');
                return false;
            }

            // 매출직원
            if (editField.staff.selectedId === '') {
                alert('매출직원을 선택하세요.');
                return false;
            }

            // 프로그램

            return true;
        },
        onClickRegist() {
            if (!this.validateValues()) {
                return false;
            }

            if (!confirm('등록하시겠습니까?')) {
                return false;
            }

            this.registContract();
        },
        onClickModify() {
            if (!this.validateValues()) {
                return false;
            }

            if (!confirm('수정하시겠습니까?')) {
                return false;
            }

            this.modifyContract();
        },
        async registContract() {
            try {
                const { data } = await this.sendPostFtContract();
                alert('계약이 등록되었습니다.');

                this.$router.push('/madmin/business/contract/list');
            } catch (error) {
                console.log(error);
                alert('오류가 발생했습니다.');
            }
        },
        sendPostFtContract() {
            const params = this.getParams();
            return api.post('/admin/api/ft/contract', {
                ...params,
            });
        },
        async modifyContract() {
            try {
                const { data } = await this.sendPutFtContract();
                console.log(data);
                alert('계약이 수정되었습니다.');

                this.$router.push(`/madmin/business/contract/detail/${this.contractInfo.centerId}`);
            } catch (error) {
                console.log(error);
                alert('오류가 발생했습니다.');
            }
        },
        sendPutFtContract() {
            const params = this.getParams();
            return api.put(`/admin/api/ft/contract/${this.contractId}`, {
                ...params,
            });
        },
        getParams() {
            const { memo, bizNo, center, staff, contractDate, program, mms, additional } = this.editField;

            const params = {
                centerId: center.id,
                contractedAt: contractDate,
                contractStaffId: staff.selectedId,
                contractName: center.contactUserName,
                contractTelNo: center.contactUserTel,
                bizType: center.bizType,
                bizNo: bizNo.join(''),
                contractTotalPrice: this.totalPrice,
                contractPrePrice: this.totalPrePrice,
                memo,
                products: [],
                bills: [], // 결제정보 : 미구현
            };

            // 프로그램 정보 입력
            if (program.selectedId !== '') {
                params.products.push({
                    id: parseInt(program.selectedId),
                    version: program.info.f_ft_prod_ver,
                    contractStartDate: program.startDate,
                    contractEndDate: program.endDate,
                    contractMonth: program.info.f_use_period,
                    ftProductBuyPrice: this.getPureNumber(program.price),
                });
            }

            if (mms.selectedValue !== '') {
                const mmsInfo = this.product.mms;
                params.products.push({
                    id: mmsInfo.f_id,
                    version: mmsInfo.f_ft_prod_ver,
                    contractStartDate: mms.startDate,
                    contractEndDate: mms.endDate,
                    contractMonth: parseInt(mms.selectedValue),
                    ftProductBuyPrice: this.getPureNumber(mms.price),
                });
            }

            for (const a of additional) {
                params.products.push({
                    id: a.f_id,
                    version: a.f_ft_prod_ver,
                    // contractStartDate: program.startDate,
                    // contractEndDate: program.endDate,
                    // contractMonth: program.info.f_use_period,
                    ftProductBuyPrice: this.getPureNumber(a.f_price),
                });
            }

            const billSeq = 0;
            for (const b of this.editField.bills) {
                console.log(this.editField.bills);
                params.bills.push({
                    centerId: center.id,
                    billSeq,
                    billPrice: this.getPureNumber(b.billPrice),
                    billDate: b.billDate,
                    payType: b.payType,
                    payCardType: b.payCardType,
                    payBankType: b.payBankType,
                });
            }

            return params;
        },
        addBills(bill) {
            if (bill === undefined) {
                console.log(this.totalPrice);
                bill = {
                    billPrice: 0,
                    payType: 'C',
                    payCardType: '',
                    payBankType: '',
                    billDate: this.today,
                };
            }

            this.editField.bills.push(bill);
        },
        onClickAddPayment() {
            this.addBills();
        },
        onChangePaymentFields(params) {
            const { data, index } = params;
            console.log('onChangePayments', params);
            this.$set(this.editField.bills, index, { ...data });
        },
        onClickDeletePaymentFields(index) {
            this.$delete(this.editField.bills, index);
        },
        onKeyUpProgramPrice() {
            const num = this.getPureNumber(this.editField.program.price);
            this.editField.program.price = this.getNumberFormat(num);
        },
        onKeyUpMmsPrice() {
            const num = this.getPureNumber(this.editField.mms.price);
            this.editField.mms.price = this.getNumberFormat(num);
        },
        onKeyUpAdditionalServicePrice(event) {
            const f_namee = event.target.id;
            const f_price = this.getPureNumber(event.target.value);
            this.product.additional.forEach((item) => {
                if (item.f_namee === f_namee) {
                    item.f_price = f_price;
                }
            });
        },
        getPureNumber(num) {
            num = num === '' ? 0 : num;
            return parseInt(num.toString().replace(/[,-]/g, ''));
        },
        getNumberFormat(num) {
            return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        },
        isNumber(evt) {
            evt = evt || window.event;
            const charCode = evt.which ? evt.which : evt.keyCode;
            if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode !== 46) {
                evt.preventDefault();
            } else {
                return true;
            }
        },
        splitBizNo(bizNo) {
            if (bizNo.length === 10) {
                return bizNo.replace(/(\d{3})(\d{2})(\d{5})/, '$1-$2-$3').split('-');
            }
            return ['', '', ''];
        },
        splitPhoneNumber(phoneNumber) {
            if (!phoneNumber) return phoneNumber;

            phoneNumber = phoneNumber.replace(/[^0-9]/g, '');

            const tmp = ['', '', ''];
            if (phoneNumber.length < 4) {
                return phoneNumber;
            } else if (phoneNumber.length < 7) {
                tmp[0] = phoneNumber.substr(0, 3);
                tmp[1] = phoneNumber.substr(3);
            } else if (phoneNumber.length == 8) {
                tmp[0] = phoneNumber.substr(0, 4);
                tmp[1] = phoneNumber.substr(4);
            } else if (phoneNumber.length < 10) {
                if (phoneNumber.substr(0, 2) == '02') {
                    // 02-123-5678
                    tmp[0] = phoneNumber.substr(0, 2);
                    tmp[1] = phoneNumber.substr(2, 3);
                    tmp[2] = phoneNumber.substr(5);
                }
            } else if (phoneNumber.length < 11) {
                if (phoneNumber.substr(0, 2) == '02') {
                    // 02-1234-5678
                    tmp[0] = phoneNumber.substr(0, 2);
                    tmp[1] = phoneNumber.substr(2, 4);
                    tmp[2] = phoneNumber.substr(6);
                } else {
                    // 010-123-4567
                    tmp[0] = phoneNumber.substr(0, 3);
                    tmp[1] = phoneNumber.substr(3, 3);
                    tmp[2] = phoneNumber.substr(6);
                }
            } else {
                // 010-1234-5678
                tmp[0] = phoneNumber.substr(0, 3);
                tmp[1] = phoneNumber.substr(3, 4);
                tmp[2] = phoneNumber.substr(7);
            }
            return tmp;
        },
    },
};
</script>
<style lang="scss"></style>
